import { gql } from '@apollo/client'

const GET_JOB_EXECUTION = gql`
  query GetJobExecution($id: String!) {
    jobExecution(id: $id) {
      id
      jobName
      status
      payload
      result
      errorMessage
      errorStack
      createdAt
      startedAt
      completedAt
      duration
      createdByUserId
      organizationId
      createdByUser {
        id
        firstName
        lastName
      }
    }
  }
`

export default GET_JOB_EXECUTION
